import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { DOCUMENTS_QUERY } from '../graphql/queries';
import { buildWikilinkResolver, type WikilinkResolver } from '../lib/wikilinks';

interface DocumentsData {
  documents: { path: string; title: string }[];
}

/**
 * A wikilink resolver over the caller's document tree, for the document
 * surfaces that render `[[wikilinks]]`. Cache-first (the app usually already
 * holds the tree) and error-ignoring: with nothing loaded the resolver simply
 * resolves nothing, and targets render as calm text — a failed tree query can
 * never degrade a document page.
 */
export function useWikilinkResolver(): WikilinkResolver {
  const { data } = useQuery<DocumentsData>(DOCUMENTS_QUERY, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'ignore',
  });
  return useMemo(() => buildWikilinkResolver(data?.documents ?? []), [data?.documents]);
}
